import Layout from "../components/common/layout.js";
import { getSession } from "next-auth/client";

export default function Contact({ session }) {
  return (
    <Layout session={session}>
      <div className="p-8 lg:p-10">
        <h1 className="text-gray-900 text-2xl font-bold mb-6">Contact</h1>

        <p className="text-gray-500 mb-4">In case of adverse events please report to Boehringer-Ingelheim Pharmacovigilance</p>

        <h6 className="uppercase text-gray-500">Phone Number:</h6>
        <p className="text-gray-500 mb-4"> +52 55 5629 8300 ext. 8379 </p>

        <h6 className="uppercase text-gray-500">E-mail:</h6>
        <p className="text-blue-500 mb-4">
          <a href="mailto:farmacovigilancia.mex@boehringer-ingelheim.com">farmacovigilancia.mex@boehringer-ingelheim.com</a>
        </p>

        <h6 className="uppercase text-gray-500">Address:</h6>
        <p className="text-gray-500 mb-10">
          <span className="block">Maíz No. 49, Col. Barrio Xaltocan, Delegación Xochimilco</span>
          <span className="block">16090, Ciudad de México, México</span>
        </p>
      </div>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  const session = await getSession(context);

  return {
    props: {
      session,
    },
  };
}
